import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { deleteWorkstationById} from '../../../../../../../../crud/management_api/workstations';


const DeleteWorkstation: React.FC<any> =  ({
      showDeleteModal,
      setShowDeleteModal,
      currentWorkstation,
      currentData,
      setCurrentData,
      onWorkstationDeleted
    }
    ) => {
      const [isDeleting, setIsDeleting] = useState(false);

      const handleDeleteWorkstation = async () => {
        if (!currentWorkstation || isDeleting) return;

        setIsDeleting(true);
        try {
          await deleteWorkstationById(
            Number(currentWorkstation.workstation_id)
          );

          toast.success('Estación de trabajo eliminada con éxito!');

          const updatedData = currentData.filter(
            (w: any) => w.workstation_id !== currentWorkstation.workstation_id
          );
          setCurrentData(updatedData);
          onWorkstationDeleted?.(currentWorkstation.workstation_id);
        } catch (error) {
          console.error('Error al eliminar estación de trabajo:', error);
          toast.error('Error al eliminar la estación de trabajo');
        } finally {
          setIsDeleting(false);
          setShowDeleteModal(false);
        }
      };
      return (
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header >
        <div className='form-modal-title-container'>
          <Modal.Title className='form-modal-title'>Confirmar eliminación</Modal.Title>
        </div>
          <Button variant="none" className="modal-close-button" onClick={() => setShowDeleteModal(false)}>
            <X size={24} /> 
          </Button>
        </Modal.Header>
        <Modal.Body>¿Estás seguro de que quieres eliminar esta estación de trabajo?</Modal.Body>
        <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button 
            className="form-button-cancel" 
            onClick={() => setShowDeleteModal(false)}
            disabled={isDeleting}
          >
            Cancelar
          </Button>
          <Button 
            className="form-button-create" 
            onClick={handleDeleteWorkstation}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Eliminando...
              </>
            ) : (
              'Eliminar'
            )}
          </Button>
        </div>
        </Modal.Footer>
      </Modal>
    )};

export default DeleteWorkstation;